export const pos = {
  seo: {
    title: 'POS system for restaurants | Bistroo',
    description: 'Bistroo quick-service POS: a modern and lightning-fast point-of-sale system for restaurants with card payments, cloud printer and direct integration with your online orders.',
  },
  hero: {
    title: {
      pt1: 'A',
      pt2: 'POS system',
      pt3: 'that checks out at lightning speed',
    },
    description:
      'The Bistroo POS is designed for quick-service restaurants that need speed and clarity. Order, process and check out. All from one intuitive system.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Ordering and checkout has never been this easy',
      text: 'The Bistroo POS processes orders at lightning speed. The clean interface is built for peak periods: fast option selection, instant confirmation and checkout in one smooth flow. Your queues stay short, your guests stay happy.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Accessible with no commitments',
      text: 'Simply plug it in and get started — no complex installations or complicated setup like traditional POS systems. From just €15 per month, you get access to a modern POS system designed for quick-service restaurants. No long-term contracts, no hidden costs.',
      cta: '',
    },
    paragraph_3: {
      title: 'Kitchen and customer receipts printed automatically',
      text: 'Every order automatically prints the correct receipt to the kitchen and the customer. Configure exactly what appears on each receipt. With seamless integration to your kitchen printer, your workflow always runs smoothly, even during the busiest periods.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Full control via the Bistroo Manager',
      text: 'Manage your menu, opening hours, staff and reports from the Bistroo Manager. View your daily revenue, close your shift with a Z-report and keep everything in order without extra software. One system for your entire operation.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Fast order input.',
        text: 'Add orders at lightning speed with clear options and variants. Built for the pace of a quick-service restaurant.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Multiple payment methods.',
        text: 'Accept PIN, contactless and split payments. Flexible checkout for every situation.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Kitchen and customer receipts.',
        text: 'Automatic receipt printing with every order, for both the kitchen and the customer.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Shift and daily closing.',
        text: 'Easily close your shift or day with a full Z-report. Always have insight into your performance.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Plug-and-play.',
        text: 'Up and running in minutes. No technical knowledge required — just switch on and start.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"With the Bistroo POS, our orders go much faster. During the lunch rush, we now handle twice as many guests as before — stress free."',
    cta: 'Read the full story',
    name: 'Sander de Vries',
    job_title: 'Owner Quick Bites',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo POS system',
    items: [
      { q: 'What is the Bistroo POS system?', a: 'The Bistroo POS is a modern point-of-sale system specifically designed for quick-service restaurants. Via a clean touchscreen interface you process orders at lightning speed, accept multiple payment methods and print receipts automatically.' },
      { q: 'How quickly can I get started with the Bistroo POS?', a: 'The Bistroo POS is up and running within minutes. No complicated installation, no technical knowledge required. Just switch on and start.' },
      { q: 'Which payment methods does the Bistroo POS accept?', a: 'The POS accepts card payments (contactless and chip), Apple Pay and Google Pay. Split payments are also possible, so a group of guests can easily split the bill.' },
      { q: 'Are orders printed automatically?', a: 'Yes. Every order automatically prints the correct receipt to the kitchen and the customer. You configure yourself what appears on each receipt and which printer receives which receipt.' },
      { q: 'What is a Z-report and how do I use it?', a: 'A Z-report is a daily closing of the till showing all revenue and transactions for the shift. Via the Bistroo POS you generate the Z-report with one tap at the end of each shift.' },
      { q: 'Can I connect the POS to my Bistroo webshop?', a: 'Yes. The Bistroo POS is fully integrated with the webshop, the ordering kiosk and QR table ordering. All orders from all channels come together in one clear system.' },
      { q: 'What hardware do I need for the Bistroo POS?', a: 'You need a tablet or touchscreen device plus a receipt printer. Bistroo also supplies a complete hardware setup. Contact us for tailored advice.' },
      { q: 'How do I update my menu via the POS?', a: 'Menu changes are made via the Bistroo Manager app, on any device. Changes are immediately visible on the POS, the webshop and any kiosks.' },
      { q: 'What does the Bistroo POS cost?', a: 'The Bistroo POS is available from €15 per month. No long-term contracts and no hidden costs. You only pay for what you use.' },
      { q: 'Can I manage multiple staff members with the Bistroo POS?', a: 'Yes. You create separate staff logins so you can always see who entered which order. Useful for shift reports and staff management.' },
    ],
  },
}
